module.exports = __webpack_public_path__ + "static/media/iphone_screen1.b30dbfa1.png";